/**
 * 进店报价 模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 进店报价详细
Mock.mock(/quote\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'commercial': {
      'insurance_effected_on': '2017-01-11',
      'insurance_expires_on': '2017-01-11',
      'items': [
        {
          'amount': 12345,
          'name': '机动车损失保险无法找到第三方特约险',
          'seats': 4
        },
        {
          'amount': 22000,
          'name': '车上人员责任险'
        },
        {
          'amount': 28582400,
          'is_select_ndi': false,
          'name': '车辆损失险'
        },
        {
          'amount': 0,
          'country_type': 2,
          'name': '玻璃单独破碎险'
        },
        {
          'amount': 1000000,
          'is_select_ndi': true,
          'name': '乘客座位险',
          'seats': 4
        },
        {
          'amount': 100000000,
          'is_select_ndi': true,
          'name': '第三者责任险'
        },
        {
          'amount': 1000000,
          'is_select_ndi': true,
          'name': '司机座位险'
        }
      ],
      'total': 12345
    },
    'compulsory': {
      'insurance_effected_on': '2017-01-11',
      'insurance_expires_on': '2017-01-11',
      'total': 12345
    },
    'insurance_company': '中国平安',
    'last_insurance_company': '未知',
    'plate_number': '粤B12345',
    'tax': 12345,
    'total': 12345,
    'vin': 'JPL48932174982174982143'
  },
  'message': 'ok'
})
